export var SapDeploymentShape;
(function (SapDeploymentShape) {
    SapDeploymentShape["SAP_DEPLOYMENT_SHAPE_ON_PREM_AGENT"] = "ON_PREM_AGENT";
    SapDeploymentShape["SAP_DEPLOYMENT_SHAPE_CLOUD_WORKER"] = "CLOUD_WORKER";
})(SapDeploymentShape || (SapDeploymentShape = {}));
